import { render, staticRenderFns } from "./index.vue?vue&type=template&id=59a3a84a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=59a3a84a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a3a84a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Calculator: require('/app/components/Calculator.vue').default,Acordian: require('/app/components/acordian.vue').default})
